/**
 * @copyright       Palace Resorts
 * @description     Mensajes para registro de facturas
 * @author          Leticia Beltrán
 * @creationDate    26/08/2021
 */

 import _ from "lodash";
 import appMessages from "@/i18n/app.messages";
 
 let moduleMessages = {
     messages: {
         ESP: {
             lblTitle: "Subcontratación",
             lblsubtitle:"Factura",
             lblProvider: "Proveedor",
             lblRFC: "RFC",
             lblGeneralData: "Datos generales",
             lblInvoice: "Folio factura",
             lblDescription: "Descripción",
             lblStartDate: "Fecha vigencia inicio",
             lblEndDate: "Fecha vigencia fin",
             lblFile: "Archivo",
             lblOrder: "Pedido",
             lblFolio: "Folio",
             lblCompany: "Sociedad",
         },
         ENG: {
             lblTitle: "Outsourcing",
             lblsubtitle: "Invoice",
             lblProvider: "Provider",
             lblRFC: "RFC",
             lblGeneralData: "General data",
             lblInvoice: "Invoice folio",
             lblDescription: "Description",
             lblStartDate: "Start date",
             lblEndDate: "End date",
             lblFile: "File",
             lblOrder: "Order",
             lblFolio: "Folio",
             lblCompany: "Company",
         },
     },
 };
 
 export default _.merge(moduleMessages, appMessages);